import React from 'react';
import { OfferFeed } from '../../../../../entities/ApplicationFeed';
import { User } from '../../../../../entities/User';
import { Application } from '../../../../../entities/Application';
import { AlertObject } from '../../../../../components/Alert';
import { GenericEntry } from '../..';
import { ActivityButton } from '../../ActivityButton';
import { Chip, ChipColor } from '../../../../../components/Chip';

interface PropTypes {
  application: Application;
  currentUser: User;
  isLastItemInPage: boolean;
  entry: OfferFeed;
  setAlert: (data: AlertObject) => void;
  reloadFeed: () => void;
}

export function OfferRejected(props: PropTypes) {
  return (
    <GenericEntry
      icon='bi-x-circle'
      iconClassName='bg-light-danger'
      title={
        <span>
          <strong>{props.application.candidate.name}</strong> {' declined the '}
          <strong>{props.application.job.name}</strong> Offer.
          {props.entry.offerId && (
            <ActivityButton
              url={`/applicant_tracking/offers/${props.entry.offerId}/preview`}
              size='sm'
              openInNewTab
              text='View Offer'
              icon='bi-box-arrow-up-right'
              className='ms-3'
            />
          )}
        </span>
      }
      date={props.entry.createdAt}
      {...props}
    >
      {props.entry.offerRejectReasons?.length > 0 && (
        <div className='d-flex flex-nowrap align-items-start'>
          <div className='d-flex w-100 rounded-3 bg-gray ms-5 py-2h px-3 gap-2 flex-wrap'>
            {props.entry.offerRejectReasons.map((reason, index) => (
              <Chip key={index} color={ChipColor.Orange}>
                {reason}
              </Chip>
            ))}
          </div>
        </div>
      )}
    </GenericEntry>
  );
}
